import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect, useCallback } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"

import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import ImageUploaders from '../tools/uploaderimages';
import { useTranslation } from 'react-i18next';
import { Selection } from 'ckeditor5';
import Swal from 'sweetalert2';
import { Radio } from 'rsuite';
import changeUrl from "../../hoc/changeur";

export default function MenuDetail() {
    let cookie = getCookies();
    const { t } = useTranslation();

    let { Id } = useParams();
    const [cookies, setCookie] = useCookies<any>(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [child, setChild] = useState<any>(null);
    const [show, setShow] = useState<boolean>(false);
    const [edit, setEdit] = useState<any>(null);

    const [data, setData] = React.useState<any>(null);
    const [activeLang, setActiveLang] = useState<string>('en');
    const languages = [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];
    const Addmenu = () => {
        var x = key + 1;
        setEdit(null);
        setChild(null);
        setShow(true);
        setKey(x);
    }
    const showedit = (id: any) => {
        var x = key + 1;

        setEdit(id);
        setChild(null);
        setShow(true);
        setKey(x);
    }
    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/menus/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            const loadedData = res.data.message;
            // Ensure multilingual structure exists
            if (loadedData) {
                if (typeof loadedData.name === 'string') {
                    loadedData.name = { ku: loadedData.name, fa: loadedData.name, en: loadedData.name, ar: loadedData.name, tr: loadedData.name };
                } else if (loadedData.name && loadedData.name.nl) {
                    loadedData.name.ku = loadedData.name.nl;
                    delete loadedData.name.nl;
                    if (!loadedData.name.tr) loadedData.name.tr = '';
                }
                if (typeof loadedData.url === 'string' || !loadedData.url) {
                    loadedData.url = loadedData.url ? { ku: loadedData.url, fa: loadedData.url, en: loadedData.url, ar: loadedData.url, tr: loadedData.url } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.url && loadedData.url.nl) {
                    loadedData.url.ku = loadedData.url.nl;
                    delete loadedData.url.nl;
                    if (!loadedData.url.tr) loadedData.url.tr = '';
                }
                if (typeof loadedData.keywords === 'string' || !loadedData.keywords) {
                    loadedData.keywords = loadedData.keywords ? { ku: loadedData.keywords, fa: loadedData.keywords, en: loadedData.keywords, ar: loadedData.keywords, tr: loadedData.keywords } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.keywords && loadedData.keywords.nl) {
                    loadedData.keywords.ku = loadedData.keywords.nl;
                    delete loadedData.keywords.nl;
                    if (!loadedData.keywords.tr) loadedData.keywords.tr = '';
                }
                if (typeof loadedData.description === 'string' || !loadedData.description) {
                    loadedData.description = loadedData.description ? { ku: loadedData.description, fa: loadedData.description, en: loadedData.description, ar: loadedData.description, tr: loadedData.description } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.description && loadedData.description.nl) {
                    loadedData.description.ku = loadedData.description.nl;
                    delete loadedData.description.nl;
                    if (!loadedData.description.tr) loadedData.description.tr = '';
                }
            }
            setData(loadedData)
            return loadedData;
        } catch (error) {
            return null;
        }
    }
    const showallmenus = async () => {
        var x = key + 1;
        setChild(null);
        setShow(false);
        setKey(x);


    }
    const addChild = async (id: any) => {
        var x = key + 1;
        setChild(id);
        setShow(true);
        setKey(x);


    }
    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    const breadcrump = [
        {
            name: t('Dashboard'),
            url: '/dashboard'
        },
        {
            name: t('Feature'),
            url: '/dashboard/Feature'
        },
        {
            name: t('Menus List'),
            url: '/dashboard/Feature/Menus'
        },
        {
            name: t('Edit Menu'),
            url: null
        }
    ]
    useEffect(() => {
        load();
    }, []);
    const [saving, setSaving] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    // Handle name change with auto-slug generation for current language
    const handleNameChange = useCallback((nameValue: string) => {
        const slugValue = String(changeUrl(nameValue));
        setData((prevData: any) => ({ 
            ...prevData, 
            name: { 
                ...prevData.name, 
                [activeLang]: nameValue 
            },
            url: {
                ...prevData.url,
                [activeLang]: slugValue
            }
        }));
    }, [activeLang]);

    const save = async () => {
        setSaving(true);
        setError(null);
        try {
            var path = `${config.url}/v1/dashboard/menus/${Id}`;
            await axios({
                method: 'put',
                url: path,
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire({
                title: t('Saved successfully'),
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
            });
            load();
        } catch (error: any) {
            if (error.response?.data?.code === 11000 || error.response?.data?.code != null) {
                // Handle uniqueness error
                const errorMessage = error.response?.data?.message || t('URL already exists');
                Swal.fire({
                    title: errorMessage,
                    icon: 'error',
                });
            } else if (error.response?.data?.message) {
                // Handle other validation errors
                if (typeof error.response.data.message === 'string') {
                    Swal.fire({
                        title: error.response.data.message,
                        icon: 'error',
                    });
                } else {
                    setError(error.response.data.message.errors);
                    Swal.fire({
                        title: t('Error saving'),
                        icon: 'error',
                    });
                }
            } else {
                Swal.fire({
                    title: t('Error saving'),
                    icon: 'error',
                });
            }
        } finally {
            setSaving(false);
        }
    }

    useEffect(() => {
        load().then(() => setLoading(false));
    }, []);

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-50 p-4 md:p-6" dir={t("dir")}>
                <div className="max-w-7xl mx-auto">
                    <BreadCrump data={breadcrump}></BreadCrump>
                    <div className="bg-white rounded-xl shadow-sm p-12 text-center mt-6">
                        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                        <p className="mt-4 text-gray-600">{t('Loading...')}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-6" dir={t("dir")}>
            <div className="max-w-7xl mx-auto">
                <BreadCrump data={breadcrump}></BreadCrump>

                {data != null && (
                    <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mt-6">
                        {/* Sidebar - Menu Group Details */}
                        <div className="lg:col-span-1">
                            <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl shadow-lg p-6 text-white sticky top-4">
                                <div className="flex items-center gap-3 mb-6">
                                    <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm">
                                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                        </svg>
                                    </div>
                                    <h4 className="text-xl font-bold">{t('Edit Detail Image')}</h4>
                                </div>
                                <div className="h-px bg-white/20 mb-6"></div>
                                
                                <form key={key} className="space-y-4">
                                    {/* Language Selector */}
                                    <div>
                                        <label className="block text-sm font-medium text-white/90 mb-2">
                                            {t('Language')}
                                        </label>
                                        <div className="flex gap-2 flex-wrap">
                                            {languages.map((lang) => (
                                                <button
                                                    key={lang.code}
                                                    type="button"
                                                    onClick={() => setActiveLang(lang.code)}
                                                    className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-colors ${
                                                        activeLang === lang.code
                                                            ? 'bg-blue-600 text-white'
                                                            : 'bg-white/10 text-white/70 hover:bg-white/20'
                                                    }`}
                                                >
                                                    {lang.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-white/90 mb-2">
                                            {t('Name')} ({languages.find(l => l.code === activeLang)?.label})
                                        </label>
                                        <input
                                            value={data.name?.[activeLang] || ''}
                                            type="text"
                                            className={`w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all ${
                                                error != null && error['name'] != undefined ? 'border-red-500 bg-red-500/20' : ''
                                            }`}
                                            placeholder={t('Name')}
                                            onChange={(e) => handleNameChange(e.target.value)}
                                        />
                                        {error != null && error['name'] != undefined && (
                                            <p className="mt-1 text-sm text-red-300">{error['name']['message']}</p>
                                        )}
                                    </div>
                                    
                                    <div>
                                        <label className="block text-sm font-medium text-white/90 mb-2">
                                            {t('Slug')} ({languages.find(l => l.code === activeLang)?.label})
                                        </label>
                                        <input
                                            type="text"
                                            value={data.url?.[activeLang] || ''}
                                            className={`w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all font-mono text-sm ${
                                                error != null && error['url'] != undefined ? 'border-red-500 bg-red-500/20' : ''
                                            }`}
                                            placeholder={t('Slug')}
                                            onChange={(e) => setData({ 
                                                ...data, 
                                                url: { 
                                                    ...data.url, 
                                                    [activeLang]: e.target.value 
                                                } 
                                            })}
                                        />
                                            {error != null && error['url'] != undefined && (
                                                <p className="mt-1 text-sm text-red-300">{error['url']['message']}</p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-white/90 mb-2">
                                                {t('Code')} <span className="text-red-400">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                value={data.code || ''}
                                                className={`w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all font-mono text-sm ${
                                                    error != null && error['code'] != undefined ? 'border-red-500 bg-red-500/20' : ''
                                                }`}
                                                placeholder={t('Code')}
                                                onChange={(e) => setData({ 
                                                    ...data, 
                                                    code: e.target.value 
                                                })}
                                            />
                                            {error != null && error['code'] != undefined && (
                                                <p className="mt-1 text-sm text-red-300">{error['code']['message']}</p>
                                            )}
                                            <p className="mt-1 text-xs text-white/60">
                                                {t('Unique code for this menu (e.g., MENU001)')}
                                            </p>
                                        </div>

                                        <button
                                        type="button"
                                        onClick={(e) => { save() }}
                                        disabled={saving || !(data.name?.[activeLang]?.trim()) || !(data.code?.trim())}
                                        className="w-full py-3 px-4 inline-flex items-center justify-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none transition-colors"
                                    >
                                        {saving ? (
                                            <>
                                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                                {t('Saving...')}
                                            </>
                                        ) : (
                                            t('Update')
                                        )}
                                    </button>
                                </form>
                            </div>
                        </div>

                        {/* Main Content - Menu Items */}
                        <div className="lg:col-span-4">
                            <div className="bg-white rounded-xl shadow-sm p-6">
                                <div className="flex items-center justify-between mb-6">
                                    <h3 className="text-xl font-bold text-gray-800">{t('Menu Items')}</h3>
                                    <button
                                        onClick={(e) => { Addmenu() }}
                                        type="button"
                                        className="py-2.5 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 transition-colors"
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                        </svg>
                                        {t('Add Menu')}
                                    </button>
                                </div>
                                
                                <div className="border-t border-gray-200 pt-6">
                                    {show == true && <AddMenu edit={edit} key={key} child={child} parent={data._id} showallmenus={showallmenus}></AddMenu>}
                                    {show == false && <ReloadMenu showedit={showedit} parent={data._id} addChild={addChild} ></ReloadMenu>}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export function ReloadMenu({ parent, addChild, showedit }: any) {
    let cookie = getCookies();
    const { t } = useTranslation();
    const [data, setData] = React.useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const arrowup = async (myid: any) => {
        //orderup
        try {
            var path = `${config.url}/v1/dashboard/menudetail/orderup/${myid}`;

            await axios({
                method: 'put',
                url: path,

                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            load();
        } catch (error) {

        }
    }
    const arrowdown = async (myid: any) => {
        //orderup
        try {
            var path = `${config.url}/v1/dashboard/menudetail/orderdown/${myid}`;

            await axios({
                method: 'put',
                url: path,

                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            load();
        } catch (error) {

        }
    }
    //
    const deleted = async (myid: any) => {
        //orderup
        try {
            var path = `${config.url}/v1/dashboard/menudetail/${myid}`;

            await axios({
                method: 'delete',
                url: path,

                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            load();
        } catch (error) {
            Swal.fire(t('have sub menu'))
        }
    }
    const edited = async (id: any) => {
        showedit(id);

    }
    const load = async () => {
        setLoading(true);
        try {
            var path = `${config.url}/v1/dashboard/menudetail/${parent}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setData(res.data.message)
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        load();
    }, []);

    if (loading) {
        return (
            <div className="text-center py-12">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <p className="mt-4 text-gray-600">{t('Loading...')}</p>
            </div>
        );
    }

    return (
        <div className='space-y-4'>
            <div className="flex items-center justify-between mb-4">
                <h4 className="text-lg font-semibold text-gray-800">{t('Menu Items')}</h4>
                <button
                    onClick={(e) => { load(); }}
                    type="button"
                    className="py-2 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition-colors"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    {t('Reload')}
                </button>
            </div>

            {data != null && data.length > 0 ? (
                <div className="space-y-3">
                    {/* Header */}
                    <div className='bg-gray-50 rounded-lg p-4 border border-gray-200'>
                        <div className='grid grid-cols-12 gap-4 items-center text-sm font-semibold text-gray-700'>
                            <div className='col-span-4'>{t('Name')} / {t('Component')}</div>
                            <div className='col-span-3'>{t('URL')}</div>
                            <div className='col-span-2 text-center'>{t('Order')}</div>
                            <div className='col-span-3 text-center'>{t('Action')}</div>
                        </div>
                    </div>
                    {data.map((item: any) => {
                        return (
                            <div key={item.id || item._id} className='bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow'>
                                <div className='grid grid-cols-12 gap-4 items-center'>
                                    <div className='col-span-4 flex items-center gap-3'>
                                        <div className="flex-1">
                                            <div className='font-semibold text-gray-900 mb-1'>
                                                {typeof item.name === 'object' 
                                                    ? (item.name.en || item.name.ku || item.name.fa || item.name.ar || item.name.tr || '') 
                                                    : (item.name || '')}
                                            </div>
                                            <div className='text-xs text-gray-500'>{t(item.component || 'component')}</div>
                                        </div>
                                        <button
                                            onClick={(e) => { addChild(item._id) }}
                                            className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors"
                                            title={t('Add Submenu')}
                                        >
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className='col-span-3'>
                                        <div className='text-sm text-gray-600 font-mono break-all'>
                                            {typeof item.url === 'object' 
                                                ? (item.url.en || item.url.ku || item.url.fa || item.url.ar || item.url.tr || '') 
                                                : (item.url || '')}
                                        </div>
                                    </div>
                                    <div className='col-span-2 flex items-center justify-center gap-2'>
                                        <button
                                            onClick={(e) => { arrowup(item.id) }}
                                            className="p-1.5 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                                            title={t('Move Up')}
                                        >
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                            </svg>
                                        </button>
                                        <button
                                            onClick={(e) => { arrowdown(item.id) }}
                                            className="p-1.5 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                                            title={t('Move Down')}
                                        >
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className='col-span-3 flex items-center justify-center gap-2'>
                                        <button
                                            onClick={(e) => { edited(item.id) }}
                                            className="px-3 py-1.5 text-sm text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors font-medium"
                                        >
                                            {t('Edit')}
                                        </button>
                                        <button
                                            onClick={(e) => { deleted(item.id) }}
                                            className="px-3 py-1.5 text-sm text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-colors font-medium"
                                        >
                                            {t('Delete')}
                                        </button>
                                    </div>
                                </div>
                                {/* Submenu Level 1 */}
                                {item.toChild && item.toChild.length > 0 && (
                                    <div className="mt-3 ml-6 space-y-2 border-l-2 border-blue-200 pl-4">
                                        {item.toChild.map((item2: any) => {
                                            return (
                                                <div key={item2.id || item2._id} className='bg-blue-50 rounded-lg border border-blue-200 p-3'>
                                                    <div className='grid grid-cols-12 gap-4 items-center'>
                                                        <div className='col-span-4 flex items-center gap-3'>
                                                            <div className="flex items-center gap-2">
                                                                <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                                                </svg>
                                                            </div>
                                                            <div className="flex-1">
                                                                <div className='font-semibold text-gray-900 mb-1'>
                                                                    {typeof item2.name === 'object' 
                                                                        ? (item2.name.en || item2.name.ku || item2.name.fa || item2.name.ar || item2.name.tr || '') 
                                                                        : (item2.name || '')}
                                                                </div>
                                                                <div className='text-xs text-gray-500'>{t(item2.component || 'component')}</div>
                                                            </div>
                                                            <button
                                                                onClick={(e) => { addChild(item2._id) }}
                                                                className="p-1.5 text-blue-600 hover:text-blue-800 hover:bg-blue-100 rounded transition-colors"
                                                                title={t('Add Submenu')}
                                                            >
                                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        <div className='col-span-3'>
                                                            <div className='text-sm text-gray-600 font-mono break-all'>
                                                                {typeof item2.url === 'object' 
                                                                    ? (item2.url.en || item2.url.ku || item2.url.fa || item2.url.ar || item2.url.tr || '') 
                                                                    : (item2.url || '')}
                                                            </div>
                                                        </div>
                                                        <div className='col-span-2 flex items-center justify-center gap-2'>
                                                            <button
                                                                onClick={(e) => { arrowup(item2.id) }}
                                                                className="p-1.5 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                                                            >
                                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                                                </svg>
                                                            </button>
                                                            <button
                                                                onClick={(e) => { arrowdown(item2.id) }}
                                                                className="p-1.5 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                                                            >
                                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        <div className='col-span-3 flex items-center justify-center gap-2'>
                                                            <button
                                                                onClick={(e) => { edited(item2.id) }}
                                                                className="px-2 py-1 text-xs text-blue-600 hover:text-blue-800 hover:bg-blue-100 rounded transition-colors"
                                                            >
                                                                {t('Edit')}
                                                            </button>
                                                            <button
                                                                onClick={(e) => { deleted(item2.id) }}
                                                                className="px-2 py-1 text-xs text-red-600 hover:text-red-800 hover:bg-red-100 rounded transition-colors"
                                                            >
                                                                {t('Delete')}
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {/* Submenu Level 2 */}
                                                    {item2.toChild && item2.toChild.length > 0 && (
                                                        <div className="mt-2 ml-4 space-y-2 border-l-2 border-purple-200 pl-3">
                                                            {item2.toChild.map((item3: any) => {
                                                                return (
                                                                    <div key={item3.id || item3._id} className='bg-purple-50 rounded-lg border border-purple-200 p-2'>
                                                                        <div className='grid grid-cols-12 gap-4 items-center'>
                                                                            <div className='col-span-4 flex items-center gap-2'>
                                                                                <svg className="w-3 h-3 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                                                                </svg>
                                                                                <div className="flex-1">
                                                                                    <div className='font-medium text-gray-900 text-sm'>
                                                                                        {typeof item3.name === 'object' 
                                                                                            ? (item3.name.en || item3.name.ku || item3.name.fa || item3.name.ar || item3.name.tr || '') 
                                                                                            : (item3.name || '')}
                                                                                    </div>
                                                                                    <div className='text-xs text-gray-500'>{t(item3.component || 'component')}</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='col-span-3'>
                                                                                <div className='text-xs text-gray-600 font-mono break-all'>
                                                                                    {typeof item3.url === 'object' 
                                                                                        ? (item3.url.en || item3.url.ku || item3.url.fa || item3.url.ar || item3.url.tr || '') 
                                                                                        : (item3.url || '')}
                                                                                </div>
                                                                            </div>
                                                                            <div className='col-span-2 flex items-center justify-center gap-1'>
                                                                                <button
                                                                                    onClick={(e) => { arrowup(item3.id) }}
                                                                                    className="p-1 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                                                                                >
                                                                                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                                                                    </svg>
                                                                                </button>
                                                                                <button
                                                                                    onClick={(e) => { arrowdown(item3.id) }}
                                                                                    className="p-1 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                                                                                >
                                                                                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                                                    </svg>
                                                                                </button>
                                                                            </div>
                                                                            <div className='col-span-3 flex items-center justify-center gap-1'>
                                                                                <button
                                                                                    onClick={(e) => { edited(item3.id) }}
                                                                                    className="px-2 py-0.5 text-xs text-blue-600 hover:text-blue-800 hover:bg-blue-100 rounded transition-colors"
                                                                                >
                                                                                    {t('Edit')}
                                                                                </button>
                                                                                <button
                                                                                    onClick={(e) => { deleted(item3.id) }}
                                                                                    className="px-2 py-0.5 text-xs text-red-600 hover:text-red-800 hover:bg-red-100 rounded transition-colors"
                                                                                >
                                                                                    {t('Delete')}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                        </div>
                    )
                })}
                </div>
            ) : (
                <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
                    <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                    <p className="mt-2 text-sm text-gray-500">{t('No menu items found')}</p>
                </div>
            )}
        </div>
    )
}

export function AddMenu({ parent, child = null, showallmenus, edit }: any) {
    let cookie = getCookies();

    const [cookies, setCookie] = useCookies<any>(['token', 'rule']);

    const slectcsc = "";
    const { t } = useTranslation();
    const [activeLang, setActiveLang] = useState<string>('en');
    const languages = [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];
    const [component, setComponent] = useState<any>(null);
    const [url, setUrl] = useState<any>('');
    const [groups, setGroup] = useState<any>(null);
    const [blogs, setBlogs] = useState<any>(null);
    const [gallery, setGallery] = useState<any>(null);
    const [prgroup, setGroupProducts] = useState<any>(null);

    const [name, setName] = useState<any>({ ku: '', fa: '', en: '', ar: '', tr: '' });
    const [megamenu, setMegameni] = useState<any>(false);
    const [transition, setTranslation] = useState<any>({});


    const [data, setData] = useState<any>(null);


    // Load All Article Group
    const loadGroup = async () => {
        try {
            var path = `${config.url}/v1/dashboard/bloggroup/all`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setGroup(res.data.message)
        } catch (error) {

        }
    }
    // Load All Articles
    const loadArticles = async () => {
        try {
            var path = `${config.url}/v1/dashboard/post/all`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setBlogs(res.data.message)
        } catch (error) {

        }
    }

    // Loadd  All Gallery /v1/dashboard/gallery
    const loadGallery = async () => {
        try {
            var path = `${config.url}/v1/dashboard/gallery/all`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setGallery(res.data.message)
        } catch (error) {

        }
    }
    const LoadGroupProducts = async () => {
        try {
            var path = `${config.url}/v1/dashboard/pgroup/getall`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setGroupProducts(res.data.message)
        } catch (error) {

        }
    }
    const LoadProducts =async ()=>{
         try {
            var path = `${config.url}/v1/dashboard/pproducts/getall`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setGroupProducts(res.data.message)
        } catch (error) {

        }
    }
    const ChangeComponent = (com: any) => {
        setComponent(com);
        setUrl('');
        if (com == "blog") {

            loadGroup();
        }
        if (com == "post") {
            loadArticles();
        }
        if (com == "gallery") {
            loadGallery();
        }
        if (com == "url") {

        }
        if (com == "productgroup") {
            LoadGroupProducts();

        }
         if (com == "products") {
            LoadProducts();

        }
    }
    const ChangeDataGroup = (data: any) => {
        setData(data);
        setUrl(data);

    }
    const ChangeDataBlog = (data: any) => {
        setData(data);
        setUrl(data);

    }
    const ChangeGroupProduct = (data: any) => {
        setData(data);
        setUrl(data);

    }
      const ChageProducts = (data: any,languageadd: any) => {
        setData(data);
        setTranslation(languageadd);
        setUrl(data);

    }
    const ChangeDataGallery = (data: any) => {
        setData(data);
        setUrl(data);

    }
    const ChangeDataUrl = (data: any) => {
        setData(data);
        setUrl(data);

    }
    const save = async () => {
        var mydata = {
            data: data,
            parent: parent,
            child: child,
            component: component,
            url: url,
            translation: transition,
            name: name
        }

        try {
            var path = `${config.url}/v1/dashboard/menudetail`;

            let res = await axios({
                method: 'post',
                url: path,
                data: mydata,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            showallmenus();
        } catch (error) {
            Swal.fire(t('Fill all the fields'))
        }
    }
    const menuGrouo = [
        {
            name: t('Blog Group'),
            url: '/group/',
            component: 'blog'

        },
        {
            name: t('Article'),
            url: '/',
            component: 'post'

        },
        {
            name: t('Gallery'),
            url: '/gallery',
            component: 'gallery'

        },
        {
            name: t('Product Group'),
            url: '/',
            component: 'productgroup'

        },
          {
            name: t('Products'),
            url: '/',
            component: 'products'

        },
        {
            name: t('URL'),
            url: '',
            component: 'url'

        }
    ]
    const update = async () => {
        var path = `${config.url}/v1/dashboard/menudetail/${edit}`;
        try {
            let res = await axios({
                method: 'put',
                url: path,
                data: {
                    name: name,
                    url: url,
                    component: component,
                    data: data,
                    megamenu: megamenu,

                },
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            showallmenus();
        } catch (error) {
            Swal.fire(t('Fill all the fields'))

        }

    }
    const loadmenu = async () => {
        try {
            var path = `${config.url}/v1/dashboard/menudetail/showedit/${edit}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            const loadedData = res.data.message;
            // Normalize multilingual fields
            if (typeof loadedData.name === 'string') {
                loadedData.name = { ku: loadedData.name, fa: loadedData.name, en: loadedData.name, ar: loadedData.name, tr: loadedData.name };
            } else if (loadedData.name && loadedData.name.nl) {
                loadedData.name.ku = loadedData.name.nl;
                delete loadedData.name.nl;
                if (!loadedData.name.tr) loadedData.name.tr = '';
            }
            if (typeof loadedData.url === 'string' || !loadedData.url) {
                loadedData.url = loadedData.url ? { ku: loadedData.url, fa: loadedData.url, en: loadedData.url, ar: loadedData.url, tr: loadedData.url } : { ku: '', fa: '', en: '', ar: '', tr: '' };
            } else if (loadedData.url && loadedData.url.nl) {
                loadedData.url.ku = loadedData.url.nl;
                delete loadedData.url.nl;
                if (!loadedData.url.tr) loadedData.url.tr = '';
            }
            setComponent(loadedData.component);
            setUrl(loadedData.url || { ku: '', fa: '', en: '', ar: '', tr: '' });
            setName(loadedData.name || { ku: '', fa: '', en: '', ar: '', tr: '' });
            setData(loadedData.data);
            setMegameni(loadedData.megamenu);
            res.data.message.component == "post" && loadArticles();
            res.data.message.component == "blog" && loadGroup();
            res.data.message.component == "gallery" && loadGallery();
            res.data.message.component == "productgroup" && LoadGroupProducts();
            res.data.message.component == "products" && LoadProducts();


        } catch (error) {

        }
    }
    useEffect(() => {
        if (edit != null) {
            loadmenu();
        }
    }, []);
    return (
        <div>
            <div className='grid grid-cols-1 sm:grid-cols-2 gap-5'>
                {/* Language Selector */}
                <div className="sm:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">{t('Language')}</label>
                    <div className="flex gap-2 flex-wrap">
                        {languages.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                onClick={() => setActiveLang(lang.code)}
                                className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-colors ${
                                    activeLang === lang.code
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Name')} ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <input
                        value={name?.[activeLang] || ''}
                        className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                        type='text'
                        onChange={(e) => { 
                            setName({ 
                                ...name, 
                                [activeLang]: e.target.value 
                            }) 
                        }}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">{t('Mega Menu')}</label>
                    <select
                        className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                        value={megamenu ? '1' : '0'}
                        onChange={(e: any) => { setMegameni(e.target.value === '1') }}
                    >
                        <option value={'0'}>{t('No')}</option>
                        <option value={'1'}>{t('Yes')}</option>
                    </select>
                </div>
                <div>
                    <label>{t('component')}</label>
                    <div>
                        <select
                            className='bg-slate-400 rounded p-2 w-full'
                            value={component}
                            onChange={(e: any) => { ChangeComponent(e.target.value) }}
                        >
                            <option></option>
                            {
                                menuGrouo.map((i: any) => {
                                    return (
                                        <option value={i.component}>{i.name}</option>
                                    )
                                })
                            }

                        </select>
                    </div>
                </div>

                <div>
                    <div>
                        <div className='text-right mb-2'>
                            {t('URL')} ({languages.find(l => l.code === activeLang)?.label})
                        </div>
                        <input
                            disabled
                            dir='ltr'
                            className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                            value={url?.[activeLang] || ''} ></input>
                    </div>
                </div>

                <div>
                    {component == "blog" && <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">{t('Select Group')}</label>
                        {groups != null &&
                            <div>
                                <select
                                    defaultValue={data}
                                    className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                                    onChange={(e: any) => { ChangeDataGroup(e.target.value) }}
                                >
                                    <option></option>
                                    {
                                        groups.map((i: any) => {
                                            const displayName = typeof i.name === 'object' 
                                                ? (i.name.en || i.name.ku || i.name.fa || i.name.ar || i.name.tr || '') 
                                                : (i.name || '');
                                            const displayUrl = typeof i.url === 'object' 
                                                ? (i.url.en || i.url.ku || i.url.fa || i.url.ar || i.url.tr || '') 
                                                : (i.url || '');
                                            return (
                                                <option value={displayUrl}>{displayName}</option>
                                            )
                                        })
                                    }

                                </select>

                            </div>
                        }
                    </div>

                    }
                    {component == "post" && <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">{t('Select Article')}</label>
                        {blogs != null &&
                            <div>
                                <select
                                    defaultValue={data}
                                    className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                                    onChange={(e: any) => { ChangeDataBlog(e.target.value) }}
                                >
                                    <option></option>
                                    {
                                        blogs.map((i: any) => {
                                            const groupName = typeof i.toGroup?.name === 'object' 
                                                ? (i.toGroup.name.en || i.toGroup.name.ku || i.toGroup.name.fa || i.toGroup.name.ar || i.toGroup.name.tr || '') 
                                                : (i.toGroup?.name || '');
                                            const blogName = typeof i.name === 'object' 
                                                ? (i.name.en || i.name.ku || i.name.fa || i.name.ar || i.name.tr || '') 
                                                : (i.name || '');
                                            const displayUrl = typeof i.url === 'object' 
                                                ? (i.url.en || i.url.ku || i.url.fa || i.url.ar || i.url.tr || '') 
                                                : (i.url || '');
                                            return (
                                                <option value={displayUrl}>{groupName} - {blogName}</option>
                                            )
                                        })
                                    }

                                </select>

                            </div>
                        }
                    </div>

                    }
                    {component == "productgroup" && <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">{t('Select Product Group')}</label>
                        {prgroup != null &&
                            <div>
                                <select
                                    defaultValue={data}
                                    className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                                    onChange={(e: any) => { ChangeGroupProduct(e.target.value) }}
                                >
                                    <option></option>
                                    {
                                        prgroup.map((i: any) => {
                                            const displayName = typeof i.name === 'object' 
                                                ? (i.name.en || i.name.ku || i.name.fa || i.name.ar || i.name.tr || '') 
                                                : (i.name || '');
                                            return (
                                                <option value={i.code}> {displayName} </option>
                                            )
                                        })
                                    }

                                </select>

                            </div>
                        }
                    </div>

                    }
                     {component == "products" && <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">{t('Select Product Group')}</label>
                        {prgroup != null &&
                            <div>
                                <select
                                    defaultValue={data}
                                    className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                                    onChange={(e: any) => { ChageProducts(e.target.value,prgroup.find((i: any) => i.code === e.target.value)?.url) }}
                                >
                                    <option></option>
                                    {
                                        prgroup.map((i: any) => {
                                            const displayName = typeof i.name === 'object' 
                                                ? (i.name.en || i.name.ku || i.name.fa || i.name.ar || i.name.tr || '') 
                                                : (i.name || '');
                                            const displayUrl = typeof i.url === 'object' 
                                                ? (i.url.en || i.url.ku || i.url.fa || i.url.ar || i.url.tr || '') 
                                                : (i.url || '');
                                            return (
                                                <option value={displayUrl}> {displayName} </option>
                                            )
                                        })
                                    }

                                </select>

                            </div>
                        }
                    </div>

                    }
                    {component == "gallery" && <div>
                        <label>{t('Select Gallery')}</label>
                        {gallery != null &&
                            <div>
                                <select
                                    defaultValue={data}
                                    className='bg-slate-400 rounded p-2 w-full text-white'
                                    onChange={(e: any) => { ChangeDataGallery(e.target.value) }}
                                >
                                    <option></option>
                                    {
                                        gallery.map((i: any) => {
                                            const displayName = typeof i.name === 'object' 
                                                ? (i.name.en || i.name.ku || i.name.fa || i.name.ar || i.name.tr || '') 
                                                : (i.name || '');
                                            const displayUrl = typeof i.url === 'object' 
                                                ? (i.url.en || i.url.ku || i.url.fa || i.url.ar || i.url.tr || '') 
                                                : (i.url || '');
                                            return (
                                                <option className='text-white' value={displayUrl}>{displayName} </option>
                                            )
                                        })
                                    }

                                </select>

                            </div>
                        }
                        {
                            edit != null && <div className='container p-4 w-[200px] m-auto'>

                            </div>

                        }
                    </div>

                    }
                    {component == "url" && <div>
                        <label>{t('Type URL')}</label>
                        <input
                            defaultValue={data}
                            className='bg-slate-400 rounded p-2 w-full text-white text-left' dir='ltr'
                            type='text' onChange={(e) => { ChangeDataUrl(e.target.value) }}></input>

                    </div>

                    }
                </div>
            </div>
            <div className='mt-3'>
                {
                    edit != null && <div className='container p-4 w-[200px] m-auto'>
                        <ImageUploader id={edit} component={'MenuDetail'}></ImageUploader>
                    </div>

                }

                <div className='w-full flex gap-1'>
                    {
                        edit == null ?
                            <button
                                onClick={(e) => {
                                    save();
                                }}
                                type="button"
                                className="py-3 m-auto  px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-500 text-white hover:bg-gray-600 focus:outline-none focus:bg-gray-600 disabled:opacity-50 disabled:pointer-events-none"
                            >
                                {t('save')}
                            </button>
                            :
                            <button
                                onClick={(e) => {
                                    update();
                                }}
                                type="button"
                                className="py-3 m-auto  px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-500 text-white hover:bg-gray-600 focus:outline-none focus:bg-gray-600 disabled:opacity-50 disabled:pointer-events-none"
                            >
                                {t('update')}
                            </button>
                    }

                    <button
                        onClick={(e) => {
                            showallmenus();
                        }}
                        type="button"
                        className="py-3 m-auto  px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-red-700 text-white hover:bg-gray-600 focus:outline-none focus:bg-gray-600 disabled:opacity-50 disabled:pointer-events-none"
                    >
                        {t('Cancel')}
                    </button>

                </div>
            </div>
        </div>
    )
}